export const hasYoutubeAttachment = attachments => {
  return (
    Array.isArray(attachments) &&
    attachments.some(att => {
      const type = String(att?.attachment_type || '')
        .trim()
        .toLowerCase()
      return type === 'youtube'
    })
  )
}

export const normalizeImageSourceByAttachments = (imageSource, attachments) => {
  const hasYoutube = hasYoutubeAttachment(attachments)

  if (hasYoutube) {
    if (imageSource == null) return 'source'
    if (imageSource === 'none') return 'none'
    return imageSource
  }

  if (imageSource === 'source') return 'imageGen'
  return imageSource
}
